import { Group, Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table"
import type { FAQ } from "@tfg/db"
import { Button } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { Table } from "~/components/table/Table"

import { FAQCreationModal } from "./FAQCreationModal"
import { FAQEditionModal } from "./FAQEditionModal"
import { useColumns } from "./columns"

const PAGE_SIZE = 50

type Props = {
  faqs: FAQ[]
}
export const FAQAdmin = ({ faqs }: Props) => {
  const { t } = useTranslation("admin")

  const columns = useColumns()

  const [sorting, setSorting] = useState<SortingState>([
    { id: "createdAt", desc: true },
  ])

  const [isCreationModalOpen, setIsCreationModalOpen] = useDisclosure(false)
  const [selectedFAQ, setSelectedFAQ] = useState<FAQ | undefined>(undefined)

  const table = useReactTable({
    data: faqs,
    columns,
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,

    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return (
    <Stack>
      <Group justify="right">
        <Button
          icon={<IconPlus />}
          onClick={setIsCreationModalOpen.toggle}
          variant="primary"
        >
          {t("faq.modal.create.title")}
        </Button>
      </Group>
      <Table table={table} onRowClick={(row) => setSelectedFAQ(row)} />
      <FAQCreationModal
        opened={isCreationModalOpen}
        onClose={setIsCreationModalOpen.close}
      />
      {selectedFAQ && (
        <FAQEditionModal
          faq={selectedFAQ}
          onClose={() => setSelectedFAQ(undefined)}
        />
      )}
    </Stack>
  )
}
